'use client'

import type { PropsWithChildren, ReactNode } from 'react'

import { Text } from '../typography/Text'

export function DialogInfoCard({ children }: PropsWithChildren) {
  return <div className={`bg-accent flex flex-col gap-4 rounded-xl p-8`}>{children}</div>
}

export function DialogInfoCardTitle({ children }: PropsWithChildren) {
  return <div className="flex items-center gap-2">{children}</div>
}

export function DialogInfoCardItem({ label, value }: { label: string; value: string | ReactNode }) {
  return (
    <div className="flex flex-col gap-2">
      <Text size="sm" className="text-muted-foreground">
        {label}
      </Text>
      <div className={`flex items-center gap-2`}>
        {typeof value === 'string' ? <Text size="sm">{value}</Text> : value}
      </div>
    </div>
  )
}
